function isEqual(obj1, obj2) {
    if (obj1 === obj2) {
        return true;
    }

    if (obj1 == null || obj2 == null) {
        return false;
    }

    if (typeof obj1 !== typeof obj2) {
        return false;
    }

    if (typeof obj1 === 'object') {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        for (let key of keys1) {
            if (!keys2.includes(key) || !isEqual(obj1[key], obj2[key])) {
                return false;
            }
        }

        return true;
    }

    return false;
}

export function deepArraySearch(arr, val) {
    for (let i = 0; i < arr.length; i++) {
        if (isEqual(arr[i], val)) {
            return i;
        }
    }
    return -1;
}